import { motion } from "framer-motion";
import { BookOpen, FileText, Scale, Landmark, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function MetaBook() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900" data-testid="meta-book-page">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 25% 25%, #991B1B 1px, transparent 1px),
                              radial-gradient(circle at 75% 75%, #1E3A8A 1px, transparent 1px)`,
            backgroundSize: '60px 60px'
          }} />
        </div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/80 text-sm mb-6">
              <BookOpen className="w-4 h-4" />
              <span>Institutional Doctrine</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Meta Book / <span className="text-[#991B1B]">Doctrine</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-white/70 max-w-3xl mx-auto mb-8">
              The constitutional framework and intellectual operating system governing 
              workforce intelligence doctrine and institutional authority.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: FileText,
                title: "Foundational Doctrine",
                description: "Core principles and philosophical foundations of workforce intelligence theory."
              },
              {
                icon: Scale,
                title: "Governance Framework",
                description: "Institutional governance structures and operational protocols."
              },
              {
                icon: Landmark,
                title: "Constitutional Architecture",
                description: "The governing framework for workforce transformation and intelligence systems."
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-[#991B1B]/20 rounded-xl flex items-center justify-center mb-6">
                  <item.icon className="w-7 h-7 text-[#991B1B]" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                <p className="text-white/60">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 border-t border-white/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Explore the Doctrine
          </h2>
          <p className="text-white/60 mb-8">
            Detailed doctrinal content coming soon. Contact us for institutional inquiries.
          </p>
          <Link to="/contact">
            <Button className="bg-[#991B1B] hover:bg-[#7f1d1d] text-white gap-2">
              Contact Institution
              <ChevronRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
